import * as React from 'react';
import { parse } from 'query-string';
import ActionSheet from '@/pages/components/common/ui/actionsheet';
import Confirm from '@/pages/components/common/ui/confirm';

import store from '@/redux/index';
import { types } from '@/redux/ui/actionsheet';
import { connect } from 'react-redux';
import * as expertEditStore from '@/redux/pages/expert-edit';
import * as confirmStore from '@/redux/ui/confirm';

import config from '@/server/config';
import request from '@/server/request';
const Toast = require('react-toast-mobile');

class ExpertEdit extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: parse(this.props.location.search).id || '', // 专家id
            isEdit: parse(this.props.location.search).edit || '0', // 是否编辑 0 否 1 是
            industryVisible: false, // 行业弹层
            industryList: [
                {
                    name: '化工',
                    value: '化工',
                }, {
                    name: '涂料',
                    value: '涂料',
                }, {
                    name: '塑料',
                    value: '塑料',
                }, {
                    name: '其他',
                    value: '其他',
                }
            ], // 行业列表
        };
    }
    public render() {
        const props = this.props;
        return (
            <section className="expert-edit">
                <div className="expert-edittop">
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            姓名
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.name} onChange={() => this.inputChange('name')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            职务
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.post}
                                onChange={() => this.inputChange('post')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            电子邮箱
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.email}
                                onChange={() => this.inputChange('email')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            手机号
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.tel}
                                onChange={() => this.inputChange('tel')} />
                        </div>
                    </div>
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <span>*</span>
                            公司名称
                        </div>
                        <div className="expert-editgroup">
                            <input type="text" placeholder="请填写" value={props.companyName}
                                onChange={() => this.inputChange('companyName')} />
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.setIndustryPopup(true)}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            您所在行业
                        </div>
                        <div className="expert-editgroup">
                            <p className={props.industry.length > 0 ? 'active' : ''}>{props.industry.length > 0 ? '已选择' : '请选择'}</p>
                            <img className="icon-right" src={require('../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    
                    {
                        props.industry.indexOf('4') > -1 ?
                            <div className="expert-edititem">
                                <div className="expert-editlabel">
                                    其他行业
                                </div>
                                <div className="expert-editgroup">
                                    <input type="text" placeholder="请填写" value={props.otherIndustry} onChange={() => this.inputChange('otherIndustry')} />
                                </div>
                            </div>
                            : null
                    }
                    <div className="expert-edititem" onClick={() => this.navigateToField()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            您擅长的领域
                        </div>
                        <div className="expert-editgroup">
                            <p className={(props.field[0] || props.field[1] || props.field[2]) ? 'active' : ''}>{props.field[0] || props.field[1] || props.field[2] || '请填写'}</p>
                            <img className="icon-right" src={require('../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                </div>
                <div className="expert-edittop">
                    <div className="expert-edititem">
                        <div className="expert-editlabel">
                            <p><span>*</span>您的个人头像</p>
                            <p><em>(要求200*200像素，或正方形图片，<br />小于1M、白底、免冠)</em></p>
                        </div>
                        <div className="expert-editgroup" onClick={() => this.photoGraph()}>
                            <div className="upload">
                                {
                                    this.props.logo ? 
                                    <img src={`${config.API}image/download/picture?imgId=${this.props.logo}`} alt="" /> : null
                                }
                                <span>+</span>
                            </div>
                        </div>
                    </div>
                    <div className="expert-edititem" onClick={() => this.navigateToIntroduction()}>
                        <div className="expert-editlabel">
                            <span>*</span>
                            自我介绍
                        </div>
                        <div className="expert-editgroup">
                            <p className={props.introduction ? 'active' : ''}>{props.introduction ? '已填写' : '请填写'}</p>
                            <img className="icon-right" src={require('../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                </div>
                <div className="expert-editbottom">
                    <div className="expert-agreement">
                        <span className={`checked ${props.agreement ? 'active' : ''}`} onClick={() => this.checkAgreement()}></span>
                        <a href="https://user.ibuychem.com/pc/uc/pages/expert/agreement.html">《买化塑专家聘用协议》</a>
                    </div>
                    <button className="btn-submit" onClick={() => this.submitAction()}>提交</button>
                </div>
                <div className={`expert-industry-popup ${this.state.industryVisible ? 'active' : ''}`}>
                    <div className="expert-ipu-mask" onClick={() => this.setIndustryPopup(false)}></div>
                    <div className="expert-ipu-content">
                        <div className="expert-ipu-head">
                            <span onClick={() => this.setIndustryPopup(false)}>取消</span>
                            <p>选择行业</p>
                            <span></span>
                        </div>
                        <div className="expert-ipu-body">
                            <div className="expert-ipu-row" onClick={() => this.selectIndustry('1')}>
                                <span className={`checked ${props.industry.indexOf('1') > -1 ? 'active' : ''}`}></span>
                                化工
                            </div>
                            <div className="expert-ipu-row" onClick={() => this.selectIndustry('3')}>
                                <span className={`checked ${props.industry.indexOf('3') > -1 ? 'active' : ''}`}></span>
                                涂料
                            </div>
                            <div className="expert-ipu-row" onClick={() => this.selectIndustry('2')}>
                                <span className={`checked ${props.industry.indexOf('2') > -1 ? 'active' : ''}`}></span>
                                塑料
                            </div>
                            <div className="expert-ipu-row" onClick={() => this.selectIndustry('4')}>
                                <span className={`checked ${props.industry.indexOf('4') > -1 ? 'active' : ''}`}></span>
                                其他
                            </div>
                        </div>
                    </div>
                </div>
                <ActionSheet project="cms" />
                <Confirm />
            </section>
        )
    }
    /**
     * 选择行业
     * @param {string} index 行业码
     */
    private selectIndustry(index: string) {
        const industry = this.props.industry;
        const currentIndex = industry.indexOf(index);
        if (currentIndex > -1) {
            industry.splice(currentIndex, 1);
        } else { 
            industry.push(index);
        }
        store.dispatch({
            type: expertEditStore.types.INPUT,
            data: {
                key: 'industry',
                value: industry
            }
        });
    }
    /**
     * 处理输入框文本变化
     * @param modelName {string} 模块名称
     */
    private inputChange(modelName: string) {
        store.dispatch({
            type: expertEditStore.types.INPUT,
            data: {
                key: modelName,
                value: (event as any).target.value
            }
        });
    }

    /**
     * 拍照上传图片
     */
    private photoGraph() {
        store.dispatch({
            type: types.ACTIONSHEET_SHOW,
            callback: (r: any) => {
                store.dispatch({
                    type: expertEditStore.types.INPUT,
                    data: {
                        key: 'logo',
                        value: r.obj
                    }
                });
            }
        });
    }

    // 跳转到擅长的领域
    private navigateToField() { 
        this.props.history.push('/expert/goodat');
    }

    // 跳转到自我介绍
    private navigateToIntroduction() {
        this.props.history.push('/expert/introduction');
    }

    // 勾选协议
    private checkAgreement() { 
        store.dispatch({
            type: expertEditStore.types.INPUT,
            data: {
                key: 'agreement',
                value: !this.props.agreement
            }
        });
    }

    /**
     * 设置行业弹层显示隐藏
     * @param visible {boolean} 显示隐藏
     */
    private setIndustryPopup(visible: boolean) { 
        this.setState({
            industryVisible: visible
        });
    }

    // 提交表单
    private async submitAction() { 
        if (this.props.name === '') {
            return Toast.T.notify('请填写姓名');
        } else if (this.props.name.length > 10) { 
            return Toast.T.notify('姓名最多只能10个字');
        } else if (this.props.post === '') {
            return Toast.T.notify('请填写职务');
        } else if (this.props.post.length > 20) { 
            return Toast.T.notify('职务最多只能20个字');
        } else if (this.props.email === '') {
            return Toast.T.notify('请填写邮箱');
        } else if (this.props.tel === '') {
            return Toast.T.notify('请填写手机号');
        } else if (isNaN(this.props.tel) || this.props.tel.length !== 11) {
            return Toast.T.notify('手机号码格式错误');
        } else if (this.props.companyName === '') {
            return Toast.T.notify('请填写公司名称');
        } else if (this.props.companyName.length > 30) { 
            return Toast.T.notify('公司名称最多只能30个字');
        } else if (this.props.industry === '') {
            return Toast.T.notify('请选择您所在行业');
        } else if (this.props.field.length === 0 || (this.props.field[0] === '' && this.props.field[1] === '' && this.props.field[2] === '')) {
            return Toast.T.notify('请填写您擅长的领域');
        } else if (this.props.logo === '') {
            return Toast.T.notify('请上传个人头像');
        } else if (this.props.introduction === '') {
            return Toast.T.notify('请填写自我介绍');
        } else if (!this.props.agreement) {
            return Toast.T.notify('请勾选《买化塑专家聘用协议》');
        }

        if (this.state.id) { 
            return this.submitData();
        }
        const r = await request({
            url: `${config.API}member/expert/check`,
            method: 'post',
            data: {
                fullName: this.props.name,
                mobile: this.props.tel
            }
        });
        if (r.code === 1) { 
            if (r.obj) {
                store.dispatch({
                    type: confirmStore.types.CONFIRM_SHOW,
                    data: {
                        text: '您已存在申请记录，是否恢复信息',
                        onConfirm: () => { 
                            this.submitData(true);
                        },
                        onHide: () => { 
                            this.submitData();
                        }
                    }
                });
            } else { 
                this.submitData();
            }
        }
        
    }

    /**
     * 提交数据
     * @param useOldData {boolean} 是否使用旧数据
     */
    private async submitData(useOldData?: boolean) { 
        const r = await request({
            url: `${config.API}member/expert/apply`,
            method: 'post',
            data: {
                id: this.state.id,
                expertCompany: this.props.companyName,
                fullname: this.props.name,
                job: this.props.post,
                email: this.props.email,
                mobile: this.props.tel,
                industry: this.props.industry.join(','),
                industryOther: this.props.otherIndustry,
                field1: this.props.field[0],
                field2: this.props.field[1],
                field3: this.props.field[2],
                logo: this.props.logo,
                description: encodeURIComponent(this.props.introduction),
                status: useOldData ? 1 : ''
            }
        });
        if (r.code === 1) {

            store.dispatch({
                type: expertEditStore.types.CLEAR
            });
            if (this.state.isEdit == '1') {
                this.props.history.push('/expert/home');
            } else { 
                this.props.history.push('/');
            }
            
        } else { 

            Toast.T.notify(r.message);
            
        }
    }
}

const mapStateToProps = (state: any):expertEditStore.IExpertEditStoreState => { 
    return {
        ...state.expertEditReducers
    }
}

export default connect(mapStateToProps)(ExpertEdit);